import '../ItemCard/styles.css';
import './styles.css';

const ItemCardSkeleton = () => (
    <div className="icard skeleton-card">
        {/* Image — same class as real card */}
        <div className="icard-img skeleton-shimmer" />

        {/* Name — same position/size as .icard-name */}
        <div className="skeleton-name-block">
            <div className="skeleton-shimmer" style={{ width: '80%', height: 16 }} />
            <div className="skeleton-shimmer" style={{ width: '55%', height: 16 }} />
        </div>

        {/* Description — same position/size as .icard-description */}
        <div className="skeleton-desc-block">
            <div className="skeleton-shimmer" style={{ width: '100%', height: 13 }} />
            <div className="skeleton-shimmer" style={{ width: '70%', height: 13 }} />
        </div>

        {/* Price — same position as .icard-price-ctn */}
        <div className="skeleton-price-block">
            <div className="skeleton-shimmer" style={{ width: 100, height: 20 }} />
        </div>

        {/* Button — uses real footer class */}
        <div className="icard-footer">
            <div className="skeleton-shimmer" style={{ width: '100%', height: 40, borderRadius: 8 }} />
        </div>
    </div>
);

export default ItemCardSkeleton;
